<template>
    <div class="advanced-options">
        <hr/>
        <div role="button" class="is-clickable" @click="open = !open">
            <i class="fas mr-2" :class="{'fa-caret-down': open, 'fa-caret-up': !open}"></i>Advanced Options
        </div>
        <div v-show="open">
            <div class="mt-4 has-text-weight-bold">
                Simple Title (for reports/reference)
                <b-input v-model="data.title" @blur="fillField"></b-input>
            </div>
            <div class="mt-4 has-text-weight-bold">
                Field ID (for fillable forms)
                <b-input v-model="data.field"></b-input>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdvancedOptions",
        props: ['data'],
        data: function() {
            return {
                open: false
            };
        },
        methods: {
            fillField() {
                if (this.data.field || !this.data.title) return;
                const id = this.data.title.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
                if (id) this.$set(this.data, 'field', id);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .advanced-options {
        margin: 0 0 1rem 2rem;
    }
</style>
